import { SendingDomainStatusEnum } from '@reach/shared-types/channels';
import styles from './SendingDomainStatusSummary.module.css';

const STATUS_LABELS: Record<SendingDomainStatusEnum, string> = {
  [SendingDomainStatusEnum.VERIFIED]: 'Verified',
  [SendingDomainStatusEnum.PENDING_VERIFICATION]: 'Verifying',
  [SendingDomainStatusEnum.NEEDS_ATTENTION]: 'Needs attention',
};

interface SendingDomainStatusSummaryProps {
  status: SendingDomainStatusEnum | null | undefined;
}

export const SendingDomainStatusSummary = ({ status }: SendingDomainStatusSummaryProps) => {
  if (!status) {
    return null;
  }

  return (
    <span className={styles.summary} data-status={status}>
      <span className={styles.dot} aria-hidden />
      <span>{STATUS_LABELS[status]}</span>
    </span>
  );
};
